export const DATE_URL_FORMAT = 'DD-MM-YYYY'
export const SUGGESTED_DATE_FORMAT = 'D MMM'
export const DATE_TIME_FORMAT = 'DD.MM.YYYY - HH:ss'
export const DATE_FORMAT = 'DD.MM.YYYY'
